/**
 * Display timezone for stay UI (pickers, calendar, formatted times).
 *
 * Occupancy math and persisted checkIn/checkOut stay UTC ISO instants.
 * Until inventory has a real IANA timezone (geolocation / Property.timezone),
 * all manager-facing stay times use this constant. Swap the value (or pass a
 * per-property zone into the helpers) when that data exists.
 */
export const STAY_DISPLAY_TIMEZONE = "Africa/Douala";

export function stayDisplayLocale(lang: string | undefined): string {
  const base = (lang ?? "en").toLowerCase();
  if (base.startsWith("fr")) return "fr";
  if (base.startsWith("es")) return "es";
  return "en";
}
